import {generatePath} from "react-router-dom";

/**
 * Routes within React Application only. Do not include legacy-ui links here as this
 * may cause unexpected side effects.
 */
const QUERY_BUILDER = '/query-builder'
const COHORT_ANALYSER = '/cohort-analyser'

export const getHistoryRoute = (isCohortAnalyser: boolean) => {
    return `${isCohortAnalyser ? COHORT_ANALYSER : QUERY_BUILDER}-history/:filter(allquery|myquery|mysavedquery|favouritequery|companyquery)`
}

export const getProgressRoute = (isCohortAnalyser: boolean) => {
    return `${isCohortAnalyser ? COHORT_ANALYSER : QUERY_BUILDER}-progress`
}

export const getVisualisationsRoute = (isCohortAnalyser: boolean) => {
    return `${isCohortAnalyser ? COHORT_ANALYSER : QUERY_BUILDER}/visualisations/:queryId`
}

export const Routes = {
    Home: '/home',
    Login: '/login',
    Projects: '/projects',
    Project: '/project/:projectId(\\d+)/:study(study)?/:studyId(\\d+)?/:subpage(period|criteria|stats)?',
    MyStudiesHRU: '/hru',
    MyStudiesPWV: '/pathway-viewer',
    MyHRU: '/hru-report',
    MyPWV: '/pathway-viewer-report',
    Glossary: '/glossary',
    Training: '/training',
    Storyboard: '/storyboard',
    MyAccount: '/my-account',
    Simulations: '/simulationsui',
    RetinaMarketTrends: '/retina-market-trends',
    VestrumPracticePerformanceTracker: '/vestrum-practice-performance-tracker',
    QueryBuilderV2: QUERY_BUILDER,
    QueryBuilderHistory: getHistoryRoute(false),
    QueryBuilderProgress: getProgressRoute(false),
    Visualisations: getVisualisationsRoute(false),
    CohortAnalyser: COHORT_ANALYSER,
    CohortAnalyserHistory: getHistoryRoute(true),
    CohortAnalyserProgress: getProgressRoute(true),
}

export const getQueryBuilderCohortAnalyserRoute = (isCohortAnalyser: boolean, cohortId?: number) => {
    return `${isCohortAnalyser ? cohortId ? buildCohortAnalyserRoute(cohortId) : COHORT_ANALYSER : QUERY_BUILDER}`
}

export const QUERY_ID = 'queryId'
export const COHORT_ID = 'cohortId'

export const buildCohortAnalyserRoute = (cohortId: number) => {
    return generatePath(`${Routes.CohortAnalyser}/:${COHORT_ID}`, {
        cohortId: cohortId
    })
}

export const buildStudyPeriodRoute = (projectId: number, studyId?: number) => {
    return generatePath(Routes.Project, {
        projectId,
        study: (studyId ?? 0) > 0 ? 'study' : undefined,
        studyId: (studyId ?? 0) > 0 ? studyId : undefined,
        subpage: 'period'
    })
}

export const buildStudyCohortRoute = (projectId: number, studyId?: number) => {
    return generatePath(Routes.Project, {
        projectId,
        study: 'study',
        studyId: studyId,
        subpage: undefined
    })
}

export const STATS = 'stats'

export const buildStudyStatsRoute = (projectId: number, studyId: number) => {
    return generatePath(Routes.Project, {
        projectId,
        study: 'study',
        studyId: studyId,
        subpage: STATS
    })
}

export const buildVisualisationsPath = (queryId: string) => {
    return generatePath(Routes.Visualisations, {
        queryId
    })
}

export const extractIntParam = (param: string | undefined) => {
    if (param === undefined) {
        return undefined
    }

    const intParam = parseInt(param)
    return isNaN(intParam) ? undefined  : intParam
}